export default angular
  .module("AliasEditCodeCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AliasEditCodeController", [
    "$scope",
    "$stateParams",
    "$rootScope",
    "System",
    function (
      $scope,
      $stateParams,
      $rootScope,
      System,
    ) {
      $scope.searchString = "";
      $scope.isShowAddNewCode = false;
      $scope.sortCodes = {};
      $scope.sortCodes.column = "CODE_SYSTEM";
      $scope.sortCodes.direction = false;
      $scope.loadingCodes = false;
      $scope.organizations = [];

      const aliasId = $stateParams.id;
      if (aliasId) {
        System.loadAliasCodes(aliasId, (aliasCodes) => {
          $scope.systemAlias.CODES = aliasCodes;
        });
      }

      const loadCodeSystems = () => {
        System.loadCodeSystems((data) => {
          $scope.codeSystems = data;
        });
      };

      const loadingCodes = () => {
        $scope.loadingCodes = true;
        System.loadAllCodesAliases("codes", (codes) => {
          $scope.availableCodes = codes;
          $scope.loadingCodes = false;
        });
      };

      $scope.loadOrganizationTags = function (query, code) {
        return $scope.organizations.filter(organization => (
          !code.organizations.some(({ NAME }) => NAME === organization.NAME) &&
          organization.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
        ));
      };

      $scope.changeSorting = function (column) {
        if ($scope.sortCodes.column === column) {
          $scope.sortCodes.direction = !$scope.sortCodes.direction;
        } else {
          $scope.sortCodes.column = column;
          $scope.sortCodes.direction = false;
        }
      };

      $scope.showAddCode = () => {
        $scope.isShowAddNewCode = !$scope.isShowAddNewCode;
        loadCodeSystems();
        loadingCodes();
      };

      $scope.saveCodeAliasCode = (code) => {
        System.saveCode(code, () => {
          System.loadAliasCodes($scope.systemAlias.SYS_ID, (aliasCodes) => {
            $scope.systemAlias.CODES = aliasCodes;
          });
          loadingCodes();
        });
      };

      $scope.removeCodeAliasCode = (code) => {
        code.ALIAS_ID = $scope.systemAlias.SYS_ID;
        System.removeCodeAliasCode(code, () => {
          System.loadAliasCodes($scope.systemAlias.SYS_ID, (aliasCodes) => {
            $scope.systemAlias.CODES = aliasCodes;
          });
        });
      };

      $scope.addCodeAliasCode = (code) => {
        code.ALIAS_ID = $scope.systemAlias.SYS_ID;
        System.addCodeAliasCode(code, () => {
          System.loadAliasCodes($scope.systemAlias.SYS_ID, (aliasCodes) => {
            $scope.systemAlias.CODES = aliasCodes;
          });
        });
      };

      $scope.addNewCodeAliasCode = (searchString) => {
        const newCode = {
          ALIAS_ID: $scope.systemAlias.SYS_ID,
          CODE: searchString.$,
          CODE_SYSTEM_ID: ($scope.codeSystems
            .find(e => e.NAME === searchString.CODE_SYSTEM) || { ID: -1 })
            .ID,
        };
        System.addNewCodeAliasCode(newCode, () => {
          System.loadAliasCodes($scope.systemAlias.SYS_ID, (aliasCodes) => {
            $scope.systemAlias.CODES = aliasCodes;
          });
          loadingCodes();
        });
      };

      System.loadOrganizationTags((organizations) => {
        $scope.organizations = organizations;
      });
    },
  ]);
